// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'
import { useState, useRef, useEffect } from 'react'
// Soft UI Dashboard PRO React components
import { PatternFormat } from 'react-number-format'
import FormField from 'components/FormField'
import { useFieldState } from 'hooks/useFieldState'
import { TextField } from '@mui/material'
import { InputAdornment } from '@mui/material'
import { ErrorOutline } from '@mui/icons-material'
import { Check } from '@mui/icons-material'
import { useFieldFocus } from 'context/FieldFocusContext'

function MuiZipcodeField({
  label,
  value,
  onChange,
  required,
  placeholder,
  onBlur,
  onFocus,
  showAdornment = false,
  enableHelpText,
  helpText,

  id,
  ...rest
}) {
  const [rawValue, setRawValue] = useState(value)
  const validateZipcode = (value) => {
    return `${value}`.match(/^\d{5}$/)
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    validatorFunction: validateZipcode,
  })
  const handleOnblurWithValidation = (e) => {
    const isValid = validateZipcode(rawValue)
    handleOnblur?.(rawValue)
    if (isValid) {
      onBlur?.(e)
    }
  }

  const { handleFocus, handleBlur, registerHelpField } = useFieldFocus()
  const inputRef = useRef(null)
  const fieldId = id || name

  useEffect(() => {
    if (enableHelpText && fieldId) {
      registerHelpField(fieldId, helpText)
    }
  }, [enableHelpText, fieldId])

  const styles = {
    '& .MuiInputLabel-asterisk': {
      color: '#ea0606',
    },

    '& input:-webkit-autofill': {
      boxShadow: '0 0 0px 1000px white inset !important',
    },

    '&>label': {
      fontSize: '14px',
      color: '#75787B',
      top: '-2px',
    },
    '&>label.Mui-focused': {
      fontSize: '1rem',
      color: '#2370ED',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.Mui-focused.Mui-error': {
      color: '#ea0606',
    },
    '&>label.MuiFormLabel-filled, &>label.MuiInputLabel-shrink': {
      fontSize: '1rem',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.MuiFormLabel-filled.Mui-disabled': {
      top: 0,
      background:
        'linear-gradient(to bottom, #fff 0%, #fff 50%, #e9ecef 50%, #e9ecef 100%)',
    },
    '&>div.MuiInputBase-root': {
      padding: '0!important',
      borderRadius: '4px !important',
    },
    '&>div.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#e9ecef!important',
    },
    '&>div.MuiInputBase-root.Mui-focused': {
      boxShadow: '0 0 0 1.5px #2370ED',
    },
    '&>div>.MuiInputBase-input': {
      width: '100%!important',
      padding: '0.75rem 1.75rem 0.75rem 0.75rem!important',
      display: 'flex',
    },
    '&>div.MuiInputBase-root>svg': {
      display: 'block',
      height: '1.5em',
      width: '1.5em',
      top: 'calc(50% - 0.75em)',
    },
  }

  return (
    <PatternFormat
      id={fieldId}
      name={fieldId}
      inputRef={inputRef}
      sx={styles}
      format="#####"
      // mask="_"
      placeholder={placeholder}
      customInput={TextField}
      label={'Zip Code'}
      value={value}
      inputProps={{ inputMode: 'numeric' }}
      // error={isError}
      // success={isSuccess}
      onFocus={(e) => {
        handleFocus(fieldId, e.target)
        onFocus?.(e)
      }}
      onBlur={handleOnblurWithValidation}
      onMouseEnter={(e) => handleFocus(fieldId, e.currentTarget)}
      onMouseLeave={(e) => {
        if (document.activeElement !== e.currentTarget) {
          handleBlur()
        }
      }}
      fullWidth
      onChange={(e) => {
        setRawValue(e.target.value)
        onChange(e)
      }}
      required={required}
      // inputProps={{ inputMode: 'tel' }}
      InputProps={{
        endAdornment: (
          <>
            {showAdornment && (
              <InputAdornment position="end">
                {isError ? (
                  <ErrorOutline
                    color="error"
                    sx={{ fontSize: '24px !important', marginRight: '8px' }}
                  />
                ) : isSuccess ? (
                  <Check
                    color="success"
                    sx={{ fontSize: '24px !important', marginRight: '8px' }}
                  />
                ) : null}
              </InputAdornment>
            )}
          </>
        ),
        inputMode: 'tel',
      }}
      // {...rest}
    />
  )
}

// typechecking props for ZipcodeField
MuiZipcodeField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default MuiZipcodeField
